const getId = () => Math.random().toString(16).slice(2);

const recommends = [
  {
    title: 'Vingadores: Ultimato da Marvel Studios',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/51FD96422640A5D092232A99544115E38035ED630B3B10848E6034D2117B093C/scale?width=400&aspectRatio=1.78&format=jpeg',
    _id: getId(),
  },
  {
    title: 'Vingadores: Guerra Infinita da Marvel Studios',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/BB0E03A68E8B92FACF38EA156687EF3E63A1C4C14E9C105BE3F049688D3B7F06/scale?width=400&aspectRatio=1.78&format=jpeg',
    _id: getId(),
  },
  {
    title: 'Star Wars: O Despertar da Força (Episódio VII)',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/B2BDD58F084C69D4535E83E5FFC0B7ED803776373D758595CFF164E9C01A8533/scale?width=400&aspectRatio=1.78&format=jpeg',
    _id: getId(),
  },
  {
    title: 'O Rei Leão',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/F8D0F68E9675617E1B8DE941EE6D1EAC8D87BBD69A7E4365928BE44CD2344D2D/scale?width=400&aspectRatio=1.78&format=jpeg',
    _id: getId(),
  },
  {
    title: 'Doutor Estranho da Marvel Studios',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/05B2A4900F7606073022B283FE11625F07DD0AF4CFA5E46332ABE5576ABB2574/scale?width=400&aspectRatio=1.78&format=jpeg',
    _id: getId(),
  },
  {
    title: 'Viúva Negra',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/D90790AA936253564925BE09CD4D0D110F01637CAA3557A656D2DE59F605458B/scale?width=400&aspectRatio=1.78&format=jpeg',
    _id: getId(),
  },
  {
    title: 'Avatar',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/9227CC7D244D50B7C3D5A5E15ABF9FC7C64D3C9CD7FE83A0DEE43CE3198FA4B0/scale?width=400&aspectRatio=1.78&format=jpeg',
    _id: getId(),
  },
  {
    title: 'Thor: Ragnarok da Marvel Studios',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/7641148A69B6658E3BEF8D154615846BFCE60A84D4C41184572CEF1FDF8237EA/scale?width=400&aspectRatio=1.78&format=jpeg',
    _id: getId(),
  },
  {
    title: 'Rogue One: Uma História Star Wars',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/A821E56D868E15C9E8F737E4011814685623CC10892384D75A416754C3127EA8/scale?width=400&aspectRatio=1.78&format=jpeg',
    _id: getId(),
  },
  {
    title: 'Procurando Nemo',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/CFF22FBD4D1F98C0B34BA4B761EB657676EE3D7FCBCBDA495ABD13EB4F397582/scale?width=400&aspectRatio=1.78&format=jpeg',
    _id: getId(),
  },
  {
    title: 'Moana: Um Mar de Aventuras',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/37835B77FBF69C94EA25A59BC25FCED323F2586E29D731E01B5B93180E30B561/scale?width=400&aspectRatio=1.78&format=jpeg',
    _id: getId(),
  },
  {
    title: 'Aladdin',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/2CB9D3025AB4895A0DB31A3CCA6EA0FB99D4BB27C8110F63043BA8C90ED34306/scale?width=400&aspectRatio=1.78&format=jpeg',
    _id: getId(),
  },
  {
    title: 'Encanto',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/BA4233111A988120193BEB3DC1231E6AE233CB0432BDE42DD5E316027F30D912/scale?width=400&aspectRatio=1.78&format=jpeg',
    _id: getId(),
  },
];

export default recommends;
